import React, { Component } from "react";
import Table from "./common/table";

class SenhasTable extends Component {

  salas = (espaco) => {   

    // 2020-10-28
    //const smile = "iVBORw0KGgoAAAANSUhEUgAAAAoAAAAKCAIAAAACUFjqAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAASSURBVChTY/iPF4xKYwH//wMA+h4q5Gx8Kc0AAAAASUVORK5CYII=";


const smile = "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"



    if (espaco) {
      let columns = [
        { path: "sala_text", label: "Sala" },
        { path: "actividade_text", label: "Actividade" },
        { path: "_id", label: "Código" },        // 2020-10-28 { path: "codigo", label: "Código" },
        { path: "nome_completo", label: "Nome" },
        { path: "hora", label: "Hora" }
      ];    
      return columns;
    } 
    else {
      let columns = [
        {
          // 2020-10-28
          path: "fotoB64",  
          content: (value) => (
            <img
              src={`data:image/jpeg;base64,${
                value === null || value === undefined || value === "" ? smile : value // base64_encode(value)
              }`}
              /*src={`data:image/jpeg;base64,${smile}`}*/
              width="50"
              height="50"
              style={{objectFit: "cover", borderRadius: "100%"}}
              alt="foto"
            />
          ),
          label: "",
        },
        { path: "_id", label: "Código" },    // 2020-10-28 { path: "codigo", label: "Código" },
        { path: "nome_completo", label: "Nome" },
        { path: "hora", label: "Hora" }
      ];    
      return columns;
    }    
    
  };

  render() {
    
    const { senhas, onSort, sortColumn, espacos_todos } = this.props;

    return (
      <Table
        columns={this.salas(espacos_todos)}
        data={senhas}
        sortColumn={sortColumn}
        onSort={onSort}
      />
    );
  }
}

export default SenhasTable;
